var _style, _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _defs39, _defs40, _defs41, _defs42, _defs43, _defs44, _defs45, _defs46, _defs47, _defs48, _defs49, _defs50, _defs51, _defs52, _defs53, _defs54, _defs55, _defs56, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKpi3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 175.2 163.5",
    style: {
      enableBackground: "new 0 0 175.2 163.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{clip-path:url(#SVGID_00000023248056228309129110000018421286607989290649_);}\n\t.st2{clip-path:url(#SVGID_00000181086278116694725170000017445142327311100316_);fill:#808080;}\n\t.st3{clip-path:url(#SVGID_00000006698293247589315870000005935616904465869719_);}\n\t.st4{clip-path:url(#SVGID_00000053528060613116048720000001122547962395621260_);fill:#808080;}\n\t.st5{clip-path:url(#SVGID_00000165933502539971338110000015082678470933601977_);}\n\t.st6{clip-path:url(#SVGID_00000003067690858737584200000017777004306098596510_);fill:#808080;}\n\t.st7{clip-path:url(#SVGID_00000001642018412464069690000000562620308901751690_);}\n\t.st8{clip-path:url(#SVGID_00000055688049903754622460000006940232694870315411_);fill:#808080;}\n\t.st9{clip-path:url(#SVGID_00000154428158548065795410000013223301992124327584_);}\n\t.st10{clip-path:url(#SVGID_00000079456508170853422750000014002607428963672484_);fill:#808080;}\n\t.st11{clip-path:url(#SVGID_00000125578807297864622830000007276121088398045347_);}\n\t.st12{clip-path:url(#SVGID_00000182487081229775895620000004774249129567989637_);fill:#808080;}\n\t.st13{clip-path:url(#SVGID_00000039119377222421470610000006405295690218442431_);}\n\t.st14{clip-path:url(#SVGID_00000124860098231837702490000011661982809492564901_);fill:#808080;}\n\t.st15{clip-path:url(#SVGID_00000004533692753920181540000005038342616727081663_);}\n\t.st16{clip-path:url(#SVGID_00000098908889524764462210000004481016883546992260_);fill:#808080;}\n\t.st17{clip-path:url(#SVGID_00000156571121547461595610000001113323361019938194_);}\n\t.st18{clip-path:url(#SVGID_00000127764645687254222130000014400174648409311361_);fill:#808080;}\n\t.st19{clip-path:url(#SVGID_00000044890211495793067690000013650070099701181322_);}\n\t.st20{clip-path:url(#SVGID_00000145027550198600973880000013541722519282060173_);fill:#808080;}\n\t.st21{clip-path:url(#SVGID_00000064329993847396343510000017156556289171575730_);}\n\t.st22{clip-path:url(#SVGID_00000175289849253367114360000014416759637072721084_);fill:#808080;}\n\t.st23{clip-path:url(#SVGID_00000029024439155703978730000009116686541941177507_);}\n\t.st24{clip-path:url(#SVGID_00000005964900572985838950000008028482843383681194_);fill:#808080;}\n\t.st25{clip-path:url(#SVGID_00000017491683966273153310000003416551132617463462_);}\n\t.st26{clip-path:url(#SVGID_00000022537049292693546160000017698522519274896310_);fill:#808080;}\n\t.st27{clip-path:url(#SVGID_00000050663891135315109690000001371201610209936827_);}\n\t.st28{clip-path:url(#SVGID_00000149359267894832250140000009089536733024227462_);fill:#808080;}\n\t.st29{clip-path:url(#SVGID_00000124877047354303838290000015520230360198449086_);}\n\t.st30{clip-path:url(#SVGID_00000060729147258754199820000016781108232438296253_);fill:#808080;}\n\t.st31{clip-path:url(#SVGID_00000016758861343351725360000012070716788136598150_);}\n\t.st32{clip-path:url(#SVGID_00000055672290804625121240000014767576873799064996_);fill:#808080;}\n\t.st33{clip-path:url(#SVGID_00000075161612587704988940000000129004381286168717_);}\n\t.st34{clip-path:url(#SVGID_00000054263462899037966140000013526570032973854099_);fill:#808080;}\n\t.st35{clip-path:url(#SVGID_00000130644314356810141090000002982232309606389905_);}\n\t.st36{clip-path:url(#SVGID_00000105398447886859134950000017996168715499726997_);fill:#808080;}\n\t.st37{clip-path:url(#SVGID_00000011030243040162864100000016681636535828068018_);}\n\t.st38{clip-path:url(#SVGID_00000080901740003169871420000008717130617510820526_);fill:#808080;}\n\t.st39{clip-path:url(#SVGID_00000181044749176538854090000007489510377955004817_);}\n\t.st40{clip-path:url(#SVGID_00000085965053325754208120000017810763394084737975_);fill:#808080;}\n\t.st41{clip-path:url(#SVGID_00000051350352502864138240000008697949868399169160_);}\n\t.st42{clip-path:url(#SVGID_00000034788759076110194240000000244255404508315298_);fill:#808080;}\n\t.st43{clip-path:url(#SVGID_00000019665548940048503750000012559264479910622375_);}\n\t.st44{clip-path:url(#SVGID_00000026137398154961074750000015441230279971323071_);fill:#808080;}\n\t.st45{clip-path:url(#SVGID_00000106110608502189328910000016920735980761890457_);}\n\t.st46{clip-path:url(#SVGID_00000167357738981041979110000007206656610499274423_);fill:#808080;}\n\t.st47{clip-path:url(#SVGID_00000072999565178269135960000015907983919257322891_);}\n\t.st48{clip-path:url(#SVGID_00000166643962136163745150000011098328592165221561_);fill:#808080;}\n\t.st49{clip-path:url(#SVGID_00000013902046018910818890000002146763122704450180_);}\n\t.st50{clip-path:url(#SVGID_00000068648048438034364550000018251165518815478452_);fill:#808080;}\n\t.st51{clip-path:url(#SVGID_00000057849284078814594900000008674133781375423130_);}\n\t.st52{clip-path:url(#SVGID_00000003077789813355576420000002406855728817024147_);fill:#808080;}\n\t.st53{clip-path:url(#SVGID_00000090273088837422498550000001138407707785878449_);}\n\t.st54{clip-path:url(#SVGID_00000023261989464328614180000017821415525335741841_);fill:#808080;}\n\t.st55{clip-path:url(#SVGID_00000155141344067800656500000005054344258794277289_);}\n\t.st56{clip-path:url(#SVGID_00000173853622246319932440000010348913430312207234_);fill:#808080;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 174,
    height: 129,
    xlinkHref: "AF3752F09D20DD70.png",
    transform: "matrix(0.9935 0 0 0.9935 1.6615 24.0568)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 24.1,
    className: "st0",
    width: 173,
    height: 128
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M30.2,76c-0.4-2.5-2.5-4.5-5.2-4.5c-2.9,0-5.2,2.3-5.2,5.2c0,2.9,2.3,5.2,5.2,5.2c2.6,0,4.8-1.9,5.2-4.5 h8.9c0.1-0.5,0.2-1,0.4-1.5h-9.3V76z M25,80.5c-2,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7s3.7,1.7,3.7,3.7S27.1,80.5,25,80.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021806319324438477130000012771882578887939488_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000021806319324438477130000012771882578887939488_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000129907512465468608650000005992001010390056583_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000141437042111130945130000017376664589387623819_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129907512465468608650000005992001010390056583_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 70.5,
    style: {
      clipPath: "url(#SVGID_00000141437042111130945130000017376664589387623819_)",
      fill: "#808080"
    },
    width: 21.6,
    height: 12.4
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044159536873476449900000013322029431006822066_",
    d: "M25,81.5c-2.6,0-4.7-2.1-4.7-4.7s2.1-4.7,4.7-4.7 c2.3,0,4.3,1.7,4.7,4l0.1,0.4h9c0,0.2-0.1,0.3-0.1,0.5h-8.9l-0.1,0.4C29.3,79.8,27.3,81.5,25,81.5 M25,72.6 c-2.3,0-4.2,1.9-4.2,4.2c0,2.3,1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2C29.2,74.4,27.3,72.6,25,72.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110460779722384029010000017831156597641445020_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044159536873476449900000013322029431006822066_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000110460779722384029010000017831156597641445020_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000078766302092640499170000006142230336959791761_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000058589582332714523610000017208039105988034200_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078766302092640499170000006142230336959791761_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.3,
    y: 71.1,
    style: {
      clipPath: "url(#SVGID_00000058589582332714523610000017208039105988034200_)",
      fill: "#808080"
    },
    width: 20.5,
    height: 11.4
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000119799570572624807510000015888087542818677936_",
    d: "M146,77.5c0.4,2.5,2.5,4.5,5.2,4.5 c2.9,0,5.2-2.3,5.2-5.2c0-2.9-2.3-5.2-5.2-5.2c-2.6,0-4.8,1.9-5.2,4.5h-9.2c0.1,0.5,0.2,1,0.4,1.5h8.8V77.5z M151.2,73.1 c2,0,3.7,1.7,3.7,3.7s-1.7,3.7-3.7,3.7s-3.7-1.7-3.7-3.7C147.5,74.7,149.1,73.1,151.2,73.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155865021770766918940000005715438138113121172_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119799570572624807510000015888087542818677936_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000155865021770766918940000005715438138113121172_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000128483722579723074070000009223929930223273347_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023274137566780053990000009936900762719835573_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128483722579723074070000009223929930223273347_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 135.8,
    y: 70.6,
    style: {
      clipPath: "url(#SVGID_00000023274137566780053990000009936900762719835573_)",
      fill: "#808080"
    },
    width: 21.6,
    height: 12.4
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000175300489521905850550000017114706480155725480_",
    d: "M151.2,81.5c-2.3,0-4.3-1.7-4.7-4l-0.1-0.4h-8.9 c0-0.2-0.1-0.3-0.1-0.5h9l0.1-0.4c0.3-2.3,2.3-4,4.7-4c2.6,0,4.7,2.1,4.7,4.7C155.9,79.4,153.8,81.5,151.2,81.5 M151.2,72.6 c-2.3,0-4.2,1.9-4.2,4.2c0,2.3,1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2C155.4,74.4,153.5,72.6,151.2,72.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000037660706013691469160000018201203806129907341_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175300489521905850550000017114706480155725480_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000037660706013691469160000018201203806129907341_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000174565656416275758720000008763751130443822729_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003795057280134244230000010503826019339962271_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174565656416275758720000008763751130443822729_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 136.4,
    y: 71.1,
    style: {
      clipPath: "url(#SVGID_00000003795057280134244230000010503826019339962271_)",
      fill: "#808080"
    },
    width: 20.5,
    height: 11.4
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000131335502025085336610000002837410585690132892_",
    d: "M25,75.5c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.2,1.3,1.2 s1.3-0.6,1.3-1.2C26.3,76.1,25.7,75.5,25,75.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061435883736314391050000004832704255257648059_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131335502025085336610000002837410585690132892_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000061435883736314391050000004832704255257648059_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000010297920955896499310000011869235025285924283_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000069372694070657375020000016123324060329499047_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010297920955896499310000011869235025285924283_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 74.5,
    style: {
      clipPath: "url(#SVGID_00000069372694070657375020000016123324060329499047_)",
      fill: "#808080"
    },
    width: 4.5,
    height: 4.5
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000131355325714168192890000005304286115839256209_",
    d: "M25,77.5c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7 c0.4,0,0.7,0.3,0.7,0.7C25.8,77.2,25.4,77.5,25,77.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047751626675249220960000018380107309565638315_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131355325714168192890000005304286115839256209_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000047751626675249220960000018380107309565638315_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000005260400147874892280000013204167276620072365_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057146522936646085620000017032857971919954863_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005260400147874892280000013204167276620072365_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 23.3,
    y: 75,
    style: {
      clipPath: "url(#SVGID_00000057146522936646085620000017032857971919954863_)",
      fill: "#808080"
    },
    width: 3.5,
    height: 3.5
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000096061592096605091100000000193338633255430570_",
    d: "M7.6,106.2h33.5c-0.2-0.5-0.4-1-0.5-1.5h-33"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108989740145158581600000008768764993349168059_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096061592096605091100000000193338633255430570_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000108989740145158581600000008768764993349168059_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000145039289372875976390000002176281405865235601_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116203001091202968920000014541557952342966939_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145039289372875976390000002176281405865235601_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 98.4,
    style: {
      clipPath: "url(#SVGID_00000116203001091202968920000014541557952342966939_)",
      fill: "#808080"
    },
    width: 34.5,
    height: 14
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000123419447528384635940000003542576307481430921_",
    d: "M23.6,104.7l0.1,0.4h16.6c0.1,0.2,0.1,0.3,0.2,0.5H23.6 l-0.1,0.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132053653860392185540000007592272788345922478_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123419447528384635940000003542576307481430921_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000132053653860392185540000007592272788345922478_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000131355198986751824710000014849347434271630742_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099644180635812359510000013820091131571641242_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131355198986751824710000014849347434271630742_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.6,
    y: 99,
    style: {
      clipPath: "url(#SVGID_00000099644180635812359510000013820091131571641242_)",
      fill: "#808080"
    },
    width: 29.8,
    height: 13
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000148649721674627054550000012790046942500525456_",
    d: "M167.3,104.7h-31.7c-0.2,0.5-0.4,1-0.5,1.5h32.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078754475941799121590000004877701678589756827_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148649721674627054550000012790046942500525456_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078754475941799121590000004877701678589756827_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000174590570058701284050000017801853597821095054_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078003467710054301720000009216699542640787125_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174590570058701284050000017801853597821095054_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 134.1,
    y: 98.4,
    style: {
      clipPath: "url(#SVGID_00000078003467710054301720000009216699542640787125_)",
      fill: "#808080"
    },
    width: 33.2,
    height: 14
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000038410937884993918120000006090169721790371753_",
    d: "M152.6,106.1l-0.1-0.4h-16.8c0.1-0.2,0.1-0.3,0.2-0.5 h16.6l0.1-0.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171715085389018014000000000169784451168920212_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000038410937884993918120000006090169721790371753_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000171715085389018014000000000169784451168920212_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000084491803971279874420000014472209283166521262_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120539597871670774460000002896694392349346457_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000084491803971279874420000014472209283166521262_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 134.8,
    y: 99,
    style: {
      clipPath: "url(#SVGID_00000120539597871670774460000002896694392349346457_)",
      fill: "#808080"
    },
    width: 29.8,
    height: 13
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000011028240614124619390000005643052618052970426_",
    d: "M133.6,88.4c0-25-20.4-45.4-45.5-45.4 S42.6,63.4,42.6,88.4s20.4,45.4,45.5,45.4S133.6,113.4,133.6,88.4 M44.5,88.4c0-24,19.6-43.6,43.6-43.6 c24.1,0,43.6,19.5,43.6,43.6c0,24-19.6,43.6-43.6,43.6C64,132,44.5,112.4,44.5,88.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038410644607228687340000002097543491038138264_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011028240614124619390000005643052618052970426_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000038410644607228687340000002097543491038138264_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000173876096353943262370000017238699089080004259_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000117638067659845295750000006191495083347771541_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173876096353943262370000017238699089080004259_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.6,
    y: 42,
    style: {
      clipPath: "url(#SVGID_00000117638067659845295750000006191495083347771541_)",
      fill: "#808080"
    },
    width: 92.9,
    height: 92.8
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000079462715656307967800000005211879889773229953_",
    d: "M88.1,133.3c-24.8,0-45-20.1-45-44.9 c0-24.7,20.2-44.9,45-44.9s45,20.1,45,44.9S112.9,133.3,88.1,133.3 M88.1,44.3C63.8,44.3,44,64.1,44,88.4s19.8,44.1,44.1,44.1 s44.1-19.8,44.1-44.1C132.3,64.1,112.5,44.3,88.1,44.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126322902195983812930000007185989212746165903_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079462715656307967800000005211879889773229953_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000126322902195983812930000007185989212746165903_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000058566239975337941520000013807158206264696980_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023992336111315517030000014147637171488055710_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058566239975337941520000013807158206264696980_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 42.2,
    y: 42.5,
    style: {
      clipPath: "url(#SVGID_00000023992336111315517030000014147637171488055710_)",
      fill: "#808080"
    },
    width: 91.9,
    height: 91.8
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000083770645972777335000000000308811891802804152_",
    d: "M97.2,36.7l0.2-1.2c-6.3-1.1-12.9-1.1-19.1,0.1l0.2,1.2 C84.6,35.7,91,35.7,97.2,36.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034072177452099965880000003494308907841097146_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083770645972777335000000000308811891802804152_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000034072177452099965880000003494308907841097146_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000005979767384923634060000015750117568121602212_",
    x: 78.3,
    y: 34.7,
    width: 19.1,
    height: 3.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000141419527333359884250000001349214791444145056_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005979767384923634060000015750117568121602212_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 77.3,
    y: 33.7,
    style: {
      clipPath: "url(#SVGID_00000141419527333359884250000001349214791444145056_)",
      fill: "#808080"
    },
    width: 21.1,
    height: 4.1
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000159433594716254904950000014189919450584508847_",
    d: "M78.9,36c3-0.5,6.1-0.8,9.2-0.8c2.9,0,5.8,0.2,8.7,0.7 v0.2c-2.8-0.5-5.7-0.7-8.6-0.7c-3.1,0-6.2,0.3-9.2,0.8L78.9,36z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127743928597999084700000010654604065300869281_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159433594716254904950000014189919450584508847_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127743928597999084700000010654604065300869281_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000070823730280143299950000008255315930653440643_",
    x: 78.9,
    y: 34.7,
    width: 17.9,
    height: 3.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124868137719753738610000007725486138710657428_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070823730280143299950000008255315930653440643_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 77.9,
    y: 34.2,
    style: {
      clipPath: "url(#SVGID_00000124868137719753738610000007725486138710657428_)",
      fill: "#808080"
    },
    width: 19.9,
    height: 3
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000016040232854278391400000012545606294086828979_",
    d: "M70.5,38.9l-0.4-1.2c-15.3,5.4-27.6,17.8-32.9,33.1 l1.2,0.4C43.6,56.3,55.6,44.2,70.5,38.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152239779599515953050000014948787666754731163_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016040232854278391400000012545606294086828979_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152239779599515953050000014948787666754731163_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000158744732942336684180000003811976492069834907_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104702782859783019000000012733131483329708731_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158744732942336684180000003811976492069834907_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 36.8,
    style: {
      clipPath: "url(#SVGID_00000104702782859783019000000012733131483329708731_)",
      fill: "#808080"
    },
    width: 35.3,
    height: 35.5
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000148636957906914538400000016258789207081315488_",
    d: "M37.9,70.5c5.3-14.8,17.2-26.7,31.9-32.1l0.1,0.2 c-14.7,5.4-26.5,17.3-31.8,32L37.9,70.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093136138581969216010000005072203015313456566_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148636957906914538400000016258789207081315488_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000093136138581969216010000005072203015313456566_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000183240142595081936650000012947332125268952754_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103987673815728730490000009808448948131539342_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183240142595081936650000012947332125268952754_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.9,
    y: 37.4,
    style: {
      clipPath: "url(#SVGID_00000103987673815728730490000009808448948131539342_)",
      fill: "#808080"
    },
    width: 34,
    height: 34.1
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000056393833037726262600000016520554240438365617_",
    d: "M34.7,81.7c-0.3,2.2-0.4,4.5-0.4,6.7 c0,4.2,0.5,8.5,1.5,12.6l1.2-0.3c-1-4-1.4-8.1-1.4-12.3c0-2.2,0.1-4.4,0.4-6.6L34.7,81.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102526500319291951770000017320077435552132768_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056393833037726262600000016520554240438365617_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000102526500319291951770000017320077435552132768_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000127750997464687520930000008762032133257792411_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003066443441884504870000003092428281223215291_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127750997464687520930000008762032133257792411_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.3,
    y: 80.7,
    style: {
      clipPath: "url(#SVGID_00000003066443441884504870000003092428281223215291_)",
      fill: "#808080"
    },
    width: 4.7,
    height: 21.3
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000183218273374489559430000012752557668970048679_",
    d: "M36.2,100.3c-0.9-3.9-1.3-7.9-1.3-11.9 c0-2.1,0.1-4.1,0.4-6.2h0.2c-0.2,2-0.4,4.1-0.4,6.1c0,4,0.4,8,1.3,11.9L36.2,100.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034770653375964436160000002006179260691590290_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183218273374489559430000012752557668970048679_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000034770653375964436160000002006179260691590290_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000029028453266061008000000018321569268993500607_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127746606081322350080000005052467355114473657_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029028453266061008000000018321569268993500607_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.8,
    y: 81.2,
    style: {
      clipPath: "url(#SVGID_00000127746606081322350080000005052467355114473657_)",
      fill: "#808080"
    },
    width: 3.5,
    height: 20.1
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000138551857194950269540000010131897340651809927_",
    d: "M68.9,138.6l0.4-1.1c-12.7-4.8-23.2-14.7-28.9-27 l-1.1,0.5C45.1,123.6,55.9,133.6,68.9,138.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158009059892385864870000017392165395845920155_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138551857194950269540000010131897340651809927_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000158009059892385864870000017392165395845920155_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000179636709255511604910000004852369460392545173_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066514680184777650450000007252838398875921045_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179636709255511604910000004852369460392545173_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.3,
    y: 109.5,
    style: {
      clipPath: "url(#SVGID_00000066514680184777650450000007252838398875921045_)",
      fill: "#808080"
    },
    width: 32,
    height: 30.1
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000073706146881854410130000004662278741108180894_",
    d: "M68.6,137.9C56.1,133,45.8,123.3,40,111.3l0.2-0.1 C45.9,123.2,56.3,132.9,68.6,137.9L68.6,137.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080175299325851818240000008883763884570898843_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000073706146881854410130000004662278741108180894_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080175299325851818240000008883763884570898843_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000132064136527682092200000017076231713648685490_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125564307629629415830000006933851055861774506_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132064136527682092200000017076231713648685490_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 110.2,
    style: {
      clipPath: "url(#SVGID_00000125564307629629415830000006933851055861774506_)",
      fill: "#808080"
    },
    width: 30.7,
    height: 28.7
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000042700484740891717560000004920776364555336071_",
    d: "M105.8,37.8l-0.4,1.2c14.9,5.3,26.9,17.4,32.1,32.3 l1.2-0.4C133.4,55.6,121.1,43.2,105.8,37.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174585062423480551070000015538988139578238593_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042700484740891717560000004920776364555336071_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000174585062423480551070000015538988139578238593_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000160152188139091104280000008985286159571490989_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177461754230215321290000007625055357759210880_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160152188139091104280000008985286159571490989_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 104.4,
    y: 36.8,
    style: {
      clipPath: "url(#SVGID_00000177461754230215321290000007625055357759210880_)",
      fill: "#808080"
    },
    width: 35.3,
    height: 35.5
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000114791992270189558810000008401966034337776287_",
    d: "M137.9,70.6c-5.3-14.7-17.1-26.6-31.8-32l0.1-0.2 c14.7,5.4,26.6,17.3,31.9,32.1L137.9,70.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023251409309832472360000016940902200806303385_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114791992270189558810000008401966034337776287_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000023251409309832472360000016940902200806303385_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000009583738370655431640000007642309670110066064_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183229477179395911510000006113282206547956143_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009583738370655431640000007642309670110066064_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.1,
    y: 37.5,
    style: {
      clipPath: "url(#SVGID_00000183229477179395911510000006113282206547956143_)",
      fill: "#808080"
    },
    width: 34,
    height: 34.1
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000089544699968844166000000011337421925859935106_",
    d: "M140.2,101c1-4.1,1.5-8.3,1.5-12.6 c0-2.3-0.1-4.5-0.4-6.7l-1.2,0.1c0.3,2.2,0.4,4.4,0.4,6.6c0,4.1-0.5,8.3-1.4,12.3L140.2,101z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178174916387260227770000000543220760113676970_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089544699968844166000000011337421925859935106_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178174916387260227770000000543220760113676970_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000129907096525436798110000004816997174745141943_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099638991589116769770000001394185797883501717_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129907096525436798110000004816997174745141943_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 80.7,
    style: {
      clipPath: "url(#SVGID_00000099638991589116769770000001394185797883501717_)",
      fill: "#808080"
    },
    width: 4.7,
    height: 21.3
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000031927384271899375150000017619636537029493941_",
    d: "M139.6,100.3c0.9-3.9,1.3-7.9,1.3-11.9 c0-2.1-0.1-4.1-0.4-6.1h0.2c0.2,2,0.4,4.1,0.4,6.2c0,4-0.5,8-1.3,11.9L139.6,100.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062879823382344968480000011057370848199794622_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031927384271899375150000017619636537029493941_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000062879823382344968480000011057370848199794622_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000014597738312765920610000011584187538526925195_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103982192138655516430000013432454524436550834_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014597738312765920610000011584187538526925195_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138.6,
    y: 81.2,
    style: {
      clipPath: "url(#SVGID_00000103982192138655516430000013432454524436550834_)",
      fill: "#808080"
    },
    width: 3.5,
    height: 20.1
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000114758744623982588360000005735851809755866768_",
    d: "M106.6,137.4l0.4,1.1c13-4.9,23.8-15,29.6-27.6 l-1.1-0.5C129.9,122.8,119.3,132.6,106.6,137.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105403135281622307170000010959915541139567498_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114758744623982588360000005735851809755866768_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105403135281622307170000010959915541139567498_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000145042916667097227350000009248109377302673811_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039118278652287004990000003625922163837738933_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145042916667097227350000009248109377302673811_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.6,
    y: 109.5,
    style: {
      clipPath: "url(#SVGID_00000039118278652287004990000003625922163837738933_)",
      fill: "#808080"
    },
    width: 32,
    height: 30.1
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000095307735431146044750000002762147935470154661_",
    d: "M107.3,137.7c12.4-4.9,22.8-14.5,28.5-26.6l0.2,0.1 c-5.8,12.1-16.2,21.8-28.6,26.7L107.3,137.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105424874784053394050000016589102614712219039_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095307735431146044750000002762147935470154661_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105424874784053394050000016589102614712219039_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000125601103575989558000000010135199145071907746_",
    x: 1.6,
    y: 24.1,
    width: 173,
    height: 128
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009569334627379734510000000780751903499530658_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000125601103575989558000000010135199145071907746_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 106.3,
    y: 110.2,
    style: {
      clipPath: "url(#SVGID_00000009569334627379734510000000780751903499530658_)",
      fill: "#808080"
    },
    width: 30.7,
    height: 28.7
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000042730511285541110000000002294794262253853348_",
    d: "M96.2,141.5l-0.2-1.2c-5.3,0.8-10.9,0.8-16.3-0.1 l-0.2,1.2c2.8,0.5,5.7,0.7,8.6,0.7C90.8,142.1,93.5,141.9,96.2,141.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096752655173735917820000010254630278696324529_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042730511285541110000000002294794262253853348_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000096752655173735917820000010254630278696324529_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000146501457940974206850000011594438393151266951_",
    x: 79.5,
    y: 138.6,
    width: 16.6,
    height: 3.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066511252004041456850000005671120311098864565_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146501457940974206850000011594438393151266951_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 139.2,
    style: {
      clipPath: "url(#SVGID_00000066511252004041456850000005671120311098864565_)",
      fill: "#808080"
    },
    width: 18.6,
    height: 3.9
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000170981889889794459530000016940022527770708649_",
    d: "M88.1,141.6c-2.7,0-5.4-0.2-8-0.6v-0.2 c2.6,0.4,5.3,0.6,8,0.6c2.5,0,5-0.2,7.4-0.5v0.2C93.1,141.4,90.6,141.6,88.1,141.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171720814872483072000000001115257342933274498_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170981889889794459530000016940022527770708649_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000171720814872483072000000001115257342933274498_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000128450760144188434050000014382372810224778891_",
    x: 80.1,
    y: 138.6,
    width: 15.5,
    height: 3.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018207918683785146790000006761750929341178248_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128450760144188434050000014382372810224778891_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 79.1,
    y: 139.8,
    style: {
      clipPath: "url(#SVGID_00000018207918683785146790000006761750929341178248_)",
      fill: "#808080"
    },
    width: 17.5,
    height: 2.8
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 34.1,
    className: "st0",
    width: 162.3,
    height: 108
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpi3);
export default __webpack_public_path__ + "static/media/kpi-3.c477316ec13a6c24a56d66715434fe4e.svg";
export { ForwardRef as ReactComponent };